/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */
import _ from 'lodash';
import { required as builtinRequired } from 'vuelidate/lib/validators';

const isOptionInArray = (option, validOptions) => {
  if (_.isObject(option)) {
    return validOptions.includes(option.value);
  }
  return validOptions.includes(option);
};

// we need to rewrite this function due to the API is responding with a
// parameter to the function, but the vuelidate builtin function does not
// require it
export const required = (isRequired = true) => {
  return isRequired ? builtinRequired : () => true;
};

export const complex = validationType => {
  switch (validationType) {
    case 'UniquenessChecker':
      // TODO: implement when the API support it
      return () => true;
    default:
      // TODO: TEMP throw error instead
      // eslint-disable-next-line no-console
      console.log(`Validation type ${validationType} is not implemented`);
      return () => true;
  }
};

export const validValues = (validValuesArray, field) => {
  return value => {
    const canBeNull = (value === null || value === undefined) && !field.mandatory;
    if (_.isArray(value)) {
      return value.every(v => isOptionInArray(v, validValuesArray)) || canBeNull;
    }

    return isOptionInArray(value, validValuesArray) || canBeNull;
  };
};

export const regex = (expression, flag) => {
  const regularExpression = new RegExp(expression, flag);
  return value => regularExpression.test(value);
};

// If not needed, we will not implement a custom function validation and the
// built-in vuelidate ones will be used
// https://vuelidate.js.org/#sub-builtin-validators
export * from 'vuelidate/lib/validators';
